import { Component } from '@angular/core';

@Component({
  selector: 'medrecord-ui-divider',
  template: '',
  styleUrls: ['./divider.component.scss']
})
export class DividerComponent {}
